{
    "BookingWizard": {
        "BooleanSwitch": {
            "no": "no",
            "yes": "yes"
        },
        "NewUserModal": {
            "emailAddress": "E-Mail",
            "firstName": "First Name",
            "holderTag": "User-Assignment",
            "holderTagPlaceholder": "Select one of the given tags",
            "lastName": "Last Name",
            "miniumAge": "User is at least %{age} years old",
            "phoneNumber": "Phone Number",
            "termsAccepted": "User accepts Terms & Conditions (current version from %{date})",
            "title": "Create a new user"
        },
        "PassengerSelector": {
            "first_name": "First Name",
            "last_name": "Last Name",
            "types": {
                "adult": "Adult",
                "adultOnly": "Person",
                "child": "Child",
                "infant": "Infant"
            }
        },
        "PaymentMethodDropdown": {
            "cash": "Cash",
            "placeholder": "Select a payment method ...",
            "placeholderWhenDisabled": "Choose a booking passenger first",
            "pos_payment": "Card payment in the vehicle",
            "service_credits": "Service Credits",
            "stripe": "Stripe default payment method"
        },
        "PickupTime": {
            "now": "Now",
            "time": "Time"
        },
        "PreBookingShortcutsModal": {
            "customDate": "Custom Date",
            "plusOneDay": "+ 1 Day",
            "plusOneWeek": "+ 1 Week",
            "titleArrival": "Arrival Time for New Booking",
            "titleDeparture": "Departure Time for New Booking"
        },
        "RideDetails": {
            "destination": "Destination",
            "driver": "Driver",
            "dropoff": "Dropoff",
            "exit": "Exit",
            "freeRide": "free ride",
            "journey": "Journey",
            "minutes": "minutes",
            "origin": "Origin",
            "pickup": "Pickup",
            "platform": "Platform",
            "price": "Price",
            "rideDetails": "Ride",
            "rideDuration": "Duration",
            "start": "Start",
            "stationInfo": "Station Information",
            "unknownDriver": "Driver has not been determined yet",
            "vehicle": "Vehicle",
            "walkingTime": "Walking time"
        },
        "RideOptions": {
            "bahncard": "BahnCard",
            "blue_badge": "Blue Badge",
            "bookForOthers": "Booking for different person",
            "passenger": "Passenger",
            "publicTransportTicket": "Public Transport Ticket",
            "storageSpaces": "Required additional storage space",
            "walker": "Walker",
            "wheelchair": "Wheelchair"
        },
        "StationDropdown": {
            "nearbyMatchingMode": {
                "false": "exact",
                "true": "nearby"
            },
            "placeholder": "Pick a station",
            "previouslyRequestedPoints": "Previous locations requested by user",
            "stations": "Stations"
        },
        "UserDropdown": {
            "newUser": "Create New User"
        },
        "buttons": {
            "addPassenger": "Add passenger",
            "book": "Book Ride",
            "bookAgain": "Book the same ride",
            "bookReturn": "Book return ride",
            "cancel": "Cancel Ride",
            "cancelModal": "Cancel",
            "create": "Find Ride",
            "createUser": "Create User",
            "newRide": "New Booking",
            "newUser": "New User",
            "ok": "Okay",
            "plusOneDay": "+ 1 Day",
            "plusOneWeek": "+ 1 Week",
            "removePassenger": "To remove a passenger choose the blank option from its dropdown"
        },
        "destination": "Destination",
        "destinationTime": "Arrival",
        "errors": {
            "no_bookable_solutions": "No result was bookable, likely all are public transport-only which we can't book. Please press \"Cancel Ride\"."
        },
        "fixedStation": "Fixed Station",
        "lookingForUsers": "Searching for fitting users...",
        "message": {
            "booking_code": "Booking Code",
            "cancelConfirmation": "The ride has already been booked. Do you want to cancel the booked ride?",
            "success": "The ride was successfully booked. Important information for the customer:",
            "title": "Ride successfully booked"
        },
        "noUsersFound": "We could not find any users matching your search",
        "option": "Option",
        "origin": "Start",
        "originTime": "Departure",
        "passengerNoteToDriver": "Passenger Note To Driver",
        "paymentMethod": "Payment method",
        "prebooking": "Ride is prebooked",
        "spinners": {
            "cloningRide": "Loading previous ride",
            "inquiring": "Inquiring ...",
            "refreshing": "Refreshing...",
            "remaining": "Remaining time",
            "searching": "Matching to vehicle...",
            "waiting_for_driver": "Waiting for driver's confirmation..."
        },
        "station": "or pick a station",
        "stationOrPreviousPoint": "or pick a station \/ previous point requested by the user",
        "stationPlaceholder": "Start typing station name...",
        "timezone": "Timezone",
        "title": "Book A Ride",
        "user": "Booking Passenger",
        "userPlaceholder": "Start typing name, phone number or customer ID...",
        "value": "Value",
        "warnings": {
            "outstanding_payments": "The user has outstanding payments on %{rides} rides with a total amount of %{amount}."
        }
    },
    "Dashboards": {
        "VehicleDisplay": {
            "minute": "minute",
            "minutes": "minutes",
            "nextStop": "Next stop in",
            "noTasks": "no rides planned"
        }
    },
    "HereMap": {
        "destination": "requested destination",
        "dropoff": "dropoff location",
        "origin": "requested origin",
        "pickup": "pickup location",
        "resetAutoZoom": "zoom automatically",
        "toggleStationVisibility": "show stations"
    },
    "LiveDashboard": {
        "completedRides": "completed rides",
        "delayDropoff": "ø delay for dropoff",
        "delayPickup": "ø delay for pickup",
        "of": "of",
        "rideRequests": "requested rides",
        "seatsInUse": "seats in use"
    },
    "_timeago": {
        "day": "a day",
        "days": "%d days",
        "hour": "about an hour",
        "hours": "about %d hours",
        "minute": "about a minute",
        "minutes": "%d minutes",
        "month": "about a month",
        "months": "%d months",
        "seconds": "less than a minute",
        "suffixAgo": "ago",
        "suffixFromNow": "from now",
        "wordSeparator": " ",
        "year": "about a year",
        "years": "%d years"
    },
    "imageUploader": {
        "altText": "Uploaded Image",
        "errorHeader": "Something went wrong",
        "processing": "Processing...",
        "resetLink": "Reset",
        "successMessage": "Image upload finished successfully!"
    },
    "sms": {
        "IncomingMessage": {
            "readAt": "at",
            "readMessage": "read by",
            "receivedMessage": "Received at"
        },
        "NewMessageInput": {
            "placeholder": "Message... (Ctrl + Enter to send)"
        },
        "OutgoingMessage": {
            "sentAt": "at",
            "sentMessage": "Sent by"
        }
    }
}